// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1k1b1he0 {
  height: 493px;
}
@media screen and (max-width: 768px) {
  ._1k1b1he0 {
    height: 280px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["._1k1b1he0 {\n  height: 493px;\n}\n@media screen and (max-width: 768px) {\n  ._1k1b1he0 {\n    height: 280px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
